import { useState } from "react";

const LS_KEY = "scanapp_heat";
const DEFAULTS = {
  opacity: 0.85,
  bgThreshold: 25,
  invertMapping: false,
  palette: "classic",
  outputBg: "white",
};

export function useHeatSettings() {
  const [settings, setSettings] = useState(() => {
    try {
      const s = localStorage.getItem(LS_KEY);
      if (s) return { ...DEFAULTS, ...JSON.parse(s) };
    } catch {}
    return { ...DEFAULTS };
  });

  const update = (partial) =>
    setSettings(prev => {
      const next = { ...prev, ...partial };
      try { localStorage.setItem(LS_KEY, JSON.stringify(next)); } catch {}
      return next;
    });

  return [settings, update];
}
